// components/LazyComponents.tsx
import { lazy, Suspense } from 'react'

// Loading components
const HeroLoader = () => (
  <div className="bg-white min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[rgb(55,134,181)]"></div>
  </div>
)

const AboutLoader = () => (
  <div className="bg-white py-24 sm:py-32 flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[rgb(55,134,181)]"></div>
  </div>
)

const ApproachLoader = () => (
  <div className="bg-gray-900 py-24 sm:py-32 flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
  </div>
)

const InsightsLoader = () => (
  <div className="lg:bg-[rgb(55,134,181)] bg-[#f5f2f7] py-24 sm:py-32 flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[rgb(55,134,181)] lg:border-white"></div>
  </div>
)

// Lazy load components
const Hero = lazy(() => import('./ui/Hero'))
const About = lazy(() => import('./ui/About'))
const Approach = lazy(() => import('./ui/Approach'))
const Insights = lazy(() => import('./ui/Insights'))

// Export wrapped with Suspense
export const LazyHero = (props: any) => (
  <Suspense fallback={<HeroLoader />}>
    <Hero {...props} />
  </Suspense>
)

export const LazyAbout = (props: any) => (
  <Suspense fallback={<AboutLoader />}>
    <About {...props} />
  </Suspense>
)

export const LazyApproach = (props: any) => (
  <Suspense fallback={<ApproachLoader />}>
    <Approach {...props} />
  </Suspense>
)

export const LazyInsights = (props: any) => (
  <Suspense fallback={<InsightsLoader />}>
    <Insights {...props} />
  </Suspense>
)

// Remove lazy loading for these as they don't fetch from Supabase:
// - Testimonials (uses static data)
// - Service (uses static data from lib/services.ts)
// - Contact (just a form, no Supabase data)